import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import NewProduct from "@/components/Products/NewProduct.vue";

export const useNewProductDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();

    const open = () => {
        dialogRef.value = dialog.open(NewProduct, {
            props: {
                header: "New product or service",
                style: {
                    maxWidth: "700px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
        });
    };

    return {
        open,
        isVisible: computed(() => Boolean(dialogRef.value?.visible)),
    };
};
